/**
 * ProductTour entity class
 */
/**
 * ProductTourFactory
 * returns ProductTour entity class
 *
 * @class ProductTourFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ProductTour} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ProductTourFactory
 */
/* @ngInject */
export default function ProductTourFactory (Entity) {
  /* === ProductTour class === */

  /**
   * ProductTour model
   *
   * @class ProductTour
   * @classdesc ProductTour model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.ProductTour} ProductTour entity
   */
  function ProductTour () {
    const obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ProductTour.prototype = Object.create(Entity.prototype)
  ProductTour.prototype.constructor = ProductTour

  /* === ProductTour instance methods & fields === */
  Object.assign(ProductTour.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ProductTour#
     * @type {Object}
     */
    _fields: {
      id: 1,
      enabled: Boolean,
      slides: [{
        id: Number,
        sortOrder: Number,
        horizontalImageUrl: String,
        verticalImageUrl: String
      }]
    },

    /**
     * url template
     *
     * @memberof models.ProductTour#
     * @type {String}
     */
    _urlTemplate: 'api/product-tour',

    /**
     * public url template
     *
     * @memberof models.ProductTour#
     * @type {String}
     */
    _publicUrlTemplate: '/apps-settings#product-tour'
  })

  // copy all static methods from Entity class
  Object.assign(ProductTour, Entity)
  ProductTour._name = 'ProductTour'
  ProductTour.init()

  // permissions
  ProductTour.access = {
    view: 'viewAppsSettings',
    edit: 'editAppsSettings',
    delete: 'deleteAppsSettings'
  }

  return ProductTour
}
